
import React from "react";

import { IconButton, Tooltip } from "@mui/material"
import { Settings } from "@mui/icons-material"
import { iconos } from "../../../data";




export const TooltipAndIcon = (({ titulo, icono, onClick, color, disabled=false }) => {

    
    return (

        <Tooltip title={titulo} placement="top">
            <span>
                <IconButton sx={{ color:"primary.main"}} 
                    onClick={ onClick } disabled={disabled}  style={{pointerEvents: disabled ? 'none' : 'auto' }}>
                    { React.cloneElement(iconos[icono], {style:{fontSize:20, color:color} }) || <Settings /> }
                </IconButton>
            </span>
        </Tooltip>

    )
})
